import { useHookFabric } from 'hooks/useHookFabric';
import { useEffect } from 'react';
import { UserInfo } from 'react-memory-optimization/dist/lib/store/user/types';
import { useUserInfo } from 'react-render-hooks';
import ym, { YMInitializer } from 'react-yandex-metrika';

const YANDEX_ACCOUNT = +(process.env?.REACT_APP_YANDEX || 0);

const YandexMetric = () => {
  const userInfo = useHookFabric<UserInfo>({ fn: useUserInfo });

  useEffect(() => {
    if (!userInfo || !YANDEX_ACCOUNT) {
      return;
    }
    try {
      ym(`${YANDEX_ACCOUNT}`, 'userParams', {
        UserID: userInfo.clientId,
        ClientID: userInfo.clientId,
      });
    } catch (error) {
      console.log('🚀 ~ yandex ~ error:', error);
    }
  }, [userInfo]);

  return (
    <YMInitializer accounts={[YANDEX_ACCOUNT]} options={{ webvisor: true }} />
  );
};

export default YandexMetric;
